import React from 'react';
import { List, ListItem, MenuButton, LoadingShimmer } from '@icarros/ids-react';
import { useHistory } from 'react-router-dom';
import { OFFERS } from '../../../../utils/routes';
import { ListItemModifier, MenuButtonModifier, MetricsWrapper } from '../style';
import { Header } from './Header';
import { usePerformanceContext } from '../../../store/contexts/performance';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';
import { PhoneScamNotify } from '../../../components/PhoneScamNotify';

export function Metrics(): JSX.Element {
  const history = useHistory();
  const { currentAd, performanceMetrics } = usePerformanceContext();

  const { exibicoesNaLista, acessosAoDetalhe } = performanceMetrics.data || {};

  return (
    <MetricsWrapper>
      <Header />
      <PhoneScamNotify
        handleCardClick={() =>
          pushSellerPFDashboardEvent('confira mais dicas', 'seguranca', {
            location: 'performance do anúncio'
          })
        }
        handleMainButtonModalClick={() =>
          pushSellerPFDashboardEvent('entendi', 'modal seguranca', {
            location: 'performance do anúncio'
          })
        }
        handleCloseModalClick={() =>
          pushSellerPFDashboardEvent('fechar', 'modal seguranca', {
            location: 'performance do anúncio'
          })
        }
      />
      <MenuButtonModifier>
        <MenuButton
          size="full"
          variant="neutralOff"
          iconName="itaufonts_sms_mensagem_chat"
          textLabel="mensagens recebidas"
          onClick={() => {
            pushSellerPFDashboardEvent('mensagens recebidas', '');
            history.push(`${OFFERS}/${currentAd.data?.id}`);
          }}
        />
      </MenuButtonModifier>

      {currentAd.isLoading || performanceMetrics.isLoading ? (
        <>
          <LoadingShimmer show height="50px" width="380px" />
          <LoadingShimmer show height="50px" width="380px" />
        </>
      ) : (
        <List>
          <ListItemModifier>
            <ListItem
              avatarIcon="itaufonts_busca_consulta"
              avatarVariant="icon"
              label="exibições em uma busca"
              descript={String(exibicoesNaLista ?? 0)}
            />
          </ListItemModifier>
          <ListItemModifier>
            <ListItem
              avatarIcon="itaufonts_busca_consulta"
              avatarVariant="icon"
              label="visitas no anúncio"
              descript={String(acessosAoDetalhe ?? 0)}
            />
          </ListItemModifier>
        </List>
      )}
    </MetricsWrapper>
  );
}
